import setSiteMeta from '../base-saving-actions/set-site-meta';

const updateCustomFontPairs = (fontPairs) =>
  fontPairs.map((fontPair) =>
    setSiteMeta(['customization', 'customFontPairs', fontPair.id], fontPair)
  );

export default updateCustomFontPairs;
